/**
 * レイヤー素材 (SVG) の入稿エラーのトースト本文 (docs/features/motion-graphics-mode-plan.md §5.2)。
 * 入稿ゲート (§3.6-8) 不合格時の差分画像は platform admin にだけ小さく添える
 * (利用者には閾値調整用の画像は見せない)。
 */
import type { LayeredIntakeError } from './layeredIntakeErrors';

export function LayeredIntakeErrorToast({
  error,
  showDiffImage,
}: {
  error: LayeredIntakeError;
  showDiffImage: boolean;
}) {
  return (
    <span data-testid="layered-intake-error" data-error-code={error.code}>
      {`アップロードエラー: ${error.message}`}
      {showDiffImage && error.diffImageBase64 && (
        <img
          src={`data:image/png;base64,${error.diffImageBase64}`}
          alt="入稿ゲートの差分画像 (管理者のみ)"
          data-testid="layered-intake-diff-image"
          style={{ display: 'block', marginTop: 6, maxWidth: 160, maxHeight: 160 }}
        />
      )}
    </span>
  );
}
